const operate = [
    {
        path: '/operate/log',
        name: 'operateManage',
        component: () => import('@/view/operate/log'),
    },
]
export default operate